import React from "react";

const Footer = () => (
  <footer>
    &copy; 2025 Data Structures & Algorithms in Java | Developed by Priyanshu
  </footer>
);

export default Footer;
